import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { branch, withProps, compose } from "recompact"
import { BackIcon, CompareIcon } from "@infotech/uikit-icons"
import { Box } from "@infotech/uikit-grid"
import DataGrid from "@infotech/uikit-datagrid"
import {
  PrimarySecondaryButton,
  PrimaryButton,
  FlatButton,
} from "@infotech/uikit-button"
import { selectValue } from "src/engine/modules/ui/selectors"
import { readPlanEventList } from "src/engine/modules/Plan/PlanEvents/actions/creators"
import { selectPlanEventsList } from "src/engine/modules/Plan/PlanEvents/selectors"
import { selectAllStatus } from "src/engine/modules/status/selectors"
import { DateRangePicker } from "@infotech/uikit-datepicker"
import Select from "@infotech/uikit-select"
import Modal from "@infotech/uikit-modal"
import DialogPanel from "@infotech/uikit-dialog-panel"
import cn from "classnames"
import uniq from "lodash/uniq"
import difference from "lodash/difference"
import { showToast } from "@infotech/uikit-toasts"
import get from "lodash/get"
import map from "lodash/map"
import { columns } from "src/containers/Events"
import planModel from "src/models/plan"
import entityApi from "src/hocs/entity"
import allEventTypes from "src/hocs/allEventTypes"
import withSideModalPending from "src/hocs/withSideModalPending"
import { numerals } from "src/constants/numerals"
import { changeStatuses, massEvents } from "./helpers"
import { typeCustomOptions } from "./typeCustomOptions"
import styles from "./styles.css"

const stringifyOrderBy = orderBy => {
  return orderBy
    ? map(orderBy, ({ id, desc }) => `${id} ${desc ? `desc` : `asc`}`).join(` `)
    : undefined
}
// Table attr
const column = columns()

const PlanEvents = props => {
  const {
    history,
    match: {
      params: { planId, scale, date },
    },
    location: { search },
    plan,
    readPlanEventList,
    areMenuCaptionsVisible,
    planEvents: {
      data,
      status: { pending },
      count,
    },
    statusOptions: { data: statusOptions, status: statusesStatus },
    eventTypeList: { data: eventTypeOptions, pending: eventTypePending },
  } = props
  const back = () =>
    history.push(`/plans/${planId}/calendar/${scale}/${date}${search}`)
  const [resetVal, resetTable] = useState(false)
  const [currentPage, setPage] = useState(0)
  const [perPage, setPerPage] = useState(50)
  const [orderBy, setOrderBy] = useState(null)

  const pages = count ? Math.ceil(count / perPage) : 0

  const [rangeFilter, setRangeFilter] = useState([])
  const [statusFilter, setStatusFilter] = useState({})
  const [eventTypeFilter, setEventTypeFilter] = useState({})

  const query = [
    rangeFilter[0]
      ? `startDateTime=gt=${rangeFilter[0]};endDateTime=lt=${rangeFilter[1]}`
      : undefined,
    statusFilter && statusFilter.label
      ? `statusCode=='${statusFilter.value}'`
      : `statusCode!=null`,
    eventTypeFilter && eventTypeFilter.label
      ? `eventTypeId=in=(${eventTypeFilter.value})`
      : undefined,
  ]

  const planUuid = get(plan, `data.uuid`)

  useEffect(() => {
    if (planUuid) {
      const offset = currentPage * perPage
      readPlanEventList({
        uuid: planUuid,
        params: {
          limit: perPage,
          offset,
          orderBy: stringifyOrderBy(orderBy),
          query: query.filter(item => !!item).join(`;`) || undefined,
        },
      })
    }
  }, [
    resetVal,
    planUuid,
    currentPage,
    perPage,
    orderBy,
    query.filter(item => !!item).join(`;`),
  ])

  const [selectedEvents, setSelectedEvents] = useState([])
  const [showModal, toggleModal] = useState(false)
  const [inValidRows, setInvalidRows] = useState([])
  const [massiveTransitions, setMassiveTransitions] = useState([])
  const [newStatus, setNewStatus] = useState(null)

  const closeModal = () => {
    setNewStatus(null)
    toggleModal(false)
  }

  const resetFilters = () => {
    setRangeFilter([])
    setStatusFilter({})
    setEventTypeFilter({})
  }

  const resetStates = () => {
    closeModal()
    setNewStatus(null)
    setSelectedEvents([])
    resetTable(!resetVal)
  }
  return (
    <Box
      loose
      className={cn(
        styles.PlanEventsWrapper,
        areMenuCaptionsVisible ? styles.MenuWidth : styles.FullWidth,
      )}
    >
      <Box loose flex className={styles.PlanEventsHeader}>
        <Box loose p="2md">
          <span onClick={back} className={styles.icon}>
            <BackIcon />
          </span>
        </Box>
        <Box loose mt="2md" className={styles.Rectangle} />
        <Box loose flex row>
          <Box loose pl="2md" pt="4px">
            <DateRangePicker
              onChange={value => {
                setSelectedEvents([])
                setRangeFilter([
                  value[0] && value[0].getTime(),
                  value[1] && value[1].getTime(),
                ])
              }}
              value={
                rangeFilter.length
                  ? [
                      rangeFilter[0] && new Date(rangeFilter[0]),
                      rangeFilter[1] && new Date(rangeFilter[1]),
                    ]
                  : []
              }
              disabled={pending}
            />
          </Box>
          <Box loose pl="2md" pt="12px" w="223px">
            <Select
              placeholder="Фильтр по типу события"
              value={eventTypeFilter.value || null}
              options={eventTypeOptions.map(item => ({
                value: item.id,
                label: item.name,
                color: item.color,
                data: item,
              }))}
              onChange={({ target: { value } }) => {
                setPage(0)
                setSelectedEvents([])
                setEventTypeFilter(value || {})
              }}
              isClearable
              isLoading={pending || eventTypePending}
              disabled={pending || eventTypePending}
              components={typeCustomOptions(eventTypeFilter)}
            />
          </Box>
          <Box loose pl="2md" pt="12px" w="223px">
            <Select
              value={statusFilter.value || null}
              options={statusOptions.map(item => ({
                value: item.code,
                label: item.name,
              }))}
              onChange={({ target: { value } }) => {
                setPage(0)
                setSelectedEvents([])
                setStatusFilter(value || {})
              }}
              isClearable
              placeholder="Фильтр по статусу"
              isLoading={pending || statusesStatus.pending}
              disabled={pending || statusesStatus.pending}
            />
          </Box>
        </Box>
        <Box loose ml="2md" mt="2md" className={styles.Rectangle} />
        <Box loose h="4md" pl="2md" pt="13px">
          <PrimarySecondaryButton
            onClick={() => {
              if (!selectedEvents.length) {
                showToast({
                  type: `warning`,
                  message: `Выберите события для перевода в другой статус.`,
                  hideIn: 5,
                })
              } else {
                changeStatuses({
                  events: selectedEvents,
                  toggleModal,
                  setInvalidRows,
                  setMassiveTransitions,
                  setNewStatus,
                })
              }
            }}
          >
            Сменить статус
          </PrimarySecondaryButton>
        </Box>
      </Box>
      <Box loose flex column className={styles.FullHeight}>
        <DataGrid
          manual
          hideUselessPagination
          getRowIsDisabled="locked"
          data={data}
          columns={column}
          pageSize={perPage}
          page={currentPage}
          onPageChange={page => setPage(page)}
          onPageSizeChange={perPage => {
            setPerPage(perPage)
            setPage(0)
          }}
          pages={pages}
          pageSizeOptions={[10, 20, 50]}
          h="100%"
          sortable={false}
          withSidesBorder
          onSortedChange={orderBy => {
            setOrderBy(orderBy.length > 0 ? orderBy : undefined)
            setPage(0)
          }}
          trColorSettings={(props, { original }) => {
            const changeColor = inValidRows.includes(original.uuid)
            return changeColor ? `#ffe3e3` : null
          }}
          onSelect={newSelected => {
            const dataUuids = data.map(item => item.uuid)
            const newSetSelected = difference(
              uniq(
                selectedEvents.concat(
                  dataUuids.filter(item => newSelected.includes(item)),
                ),
              ),
              dataUuids.filter(item => !newSelected.includes(item)),
            )
            setSelectedEvents(newSetSelected)
          }}
          selection={data
            .map(item => item.uuid)
            .filter(item => selectedEvents.includes(item))}
          primaryKey="uuid"
          sorted={orderBy || []}
        />
      </Box>
      {showModal && (
        <Modal onClickOutside={closeModal}>
          <DialogPanel title="Смена статуса" icon={CompareIcon}>
            <Box loose>
              <Box>
                Сменить {selectedEvents.length}
                {numerals(selectedEvents.length, [
                  ` событие `,
                  ` события `,
                  ` событий `,
                ])}
                со статусом «{get(massiveTransitions, `from.name`)}» на статус
                из списка ниже.
              </Box>
              <Box w="270px">
                <Select
                  palceholder="Выберите статус"
                  value={newStatus}
                  options={get(
                    massiveTransitions,
                    `transitionsTo`,
                    [],
                  ).map(option => ({ value: option.code, label: option.name }))}
                  onChange={({ target: { value: option } }) => {
                    setNewStatus(option)
                  }}
                />
              </Box>
            </Box>
            <DialogPanel.Footer>
              <PrimaryButton
                onClick={() => {
                  if (newStatus) {
                    massEvents({
                      events: selectedEvents,
                      newStatus,
                      setInvalidRows,
                      setSelectedEvents,
                      resetStates,
                      resetFilters,
                    })
                  }
                }}
              >
                Подтвердить
              </PrimaryButton>
              <FlatButton onClick={closeModal}>Отменить</FlatButton>
            </DialogPanel.Footer>
          </DialogPanel>
        </Modal>
      )}
    </Box>
  )
}

export default compose(
  withProps(({ match: { params: { planId } } }) => ({ id: planId })),
  branch(
    ({ id }) => !!id,
    compose(
      entityApi({
        to: `plan`,
        model: planModel,
        idPropName: `id`,
      }),
      allEventTypes({ to: `eventTypeList` }),
      withSideModalPending(`plan`, `План не найден`, true),
    ),
  ),
  connect(
    state => ({
      areMenuCaptionsVisible: selectValue(state, `areMenuCaptionsVisible`),
      planEvents: selectPlanEventsList(state),
      statusOptions: selectAllStatus(state),
    }),
    {
      readPlanEventList,
    },
  ),
)(PlanEvents)
